import React, { Component } from 'react';
import InputRange from 'react-input-range';
import classnames from 'classnames';

import 'react-input-range/lib/css/index.css';

class RangeInput extends Component {
  get barColor() {
    return this.props.barColor;
  }

  handleRangeChange = (value) => {
    this.props.changeHandler(value);
  }

  render() {
    const {
      budget,
      className,
      disabled = false
    } = this.props;
    
    const maxTaxValue = budget.council.max_tax / 14.28;

    return (
      <div className={classnames('c-range', className)} id="counciltax-slider">
        <div className="c-range__min-max-wrap">
          <span className="c-range__min-value">0%</span>
          <span className="c-range__max-value">5%</span>
        </div>

        <InputRange
          formatLabel={() => `${((budget.council.value_tax / maxTaxValue) * 100).toFixed(1)}%`}
          minValue={budget.council.initial_tax}
          maxValue={maxTaxValue}
          value={budget.council.value_tax ? budget.council.value_tax : 0}
          onChange={(value) => this.handleRangeChange(value)}
          disabled={disabled}
          step={budget.council.max_tax/200} 
        />
      </div>
    )
  }
}

export default RangeInput;



// WEBPACK FOOTER //
// ./src/components/common/range/RangeInput.jsx